"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Communicator = void 0;
const popup_1 = require("./popup");
class Communicator {
    constructor(url) {
        this.popup = null;
        this.listeners = new Map();
        this.disconnect = () => {
            (0, popup_1.closePopup)(this.popup);
            this.popup = null;
            this.listeners.forEach(({ reject }, listener) => {
                reject(new Error("Request rejected: Popup closed"));
                window.removeEventListener("message", listener);
            });
            this.listeners.clear();
        };
        this.url = new URL(url);
    }
    postMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("postMessage", message);
            const popup = yield this.waitForPopupLoaded();
            popup.postMessage(message, this.url.origin);
        });
    }
    postRequestAndWaitForResponse(request) {
        return __awaiter(this, void 0, void 0, function* () {
            console.log("postRequestAndWaitForResponse", request);
            const responsePromise = this.onMessage(({ id }) => id === request.id);
            yield this.postMessage(request);
            return yield responsePromise;
        });
    }
    onMessage(predicate) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const listener = (event) => {
                    if (event.origin !== this.url.origin)
                        return;
                    const message = event.data;
                    if (predicate(message)) {
                        resolve(message);
                        window.removeEventListener("message", listener);
                        this.listeners.delete(listener);
                    }
                };
                window.addEventListener("message", listener);
                this.listeners.set(listener, { reject });
            });
        });
    }
    waitForPopupLoaded() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.popup && !this.popup.closed) {
                // In case the user un-focused the popup between requests, focus it again
                console.log("popup already loaded, but not focused");
                this.popup.focus();
                return this.popup;
            }
            console.log("waitForPopupLoaded...");
            this.popup = (0, popup_1.openPopup)(this.url);
            this.onMessage(({ event }) => event === "PopupUnload")
                .then(() => this.disconnect())
                .catch(() => { });
            return this.onMessage(({ event }) => event === "PopupLoaded")
                .then(() => {
                console.log("the window has been loaded!");
            })
                .then(() => {
                if (!this.popup)
                    throw new Error("Internal error: Popup is null");
                return this.popup;
            });
        });
    }
}
exports.Communicator = Communicator;
